<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar />
      </flex-col>
      <flex-col :span="24">
        <meta-tags :items="tags" @before-destroy="onBeforeDestroy" @meta-tags-script-1-ready="onMetaTagsScript1Ready" />
      </flex-col>
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageMetaTags',
  mixins: [
    methods
  ],
  data () {
    return {
      tags: []
    }
  },
  mounted () {
    this.getExternalData('meta-tags.json', 'tags')
  },
  methods: {
    onMetaTagsScript1Ready () {
      window.externallyLoadedClassInstance.init()
    },
    onBeforeDestroy () {
      this.log('before-destroy', 'meta-tags', null)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/content/meta-tags.vue